<template>
  <div>
  <el-table
    :empty-text="emptyText"
    :data="rows"
    v-loading="loading"
    :element-loading-text="$tableLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255,255,255,0)"
    :header-cell-style="tableHeaderColor"
    :max-height="$tableMaxHeight"
    @selection-change="handleSelectionChange"
    border
  >
    <el-table-column
        type="selection"
        align="center"
        width="55"
    ></el-table-column>
    <el-table-column type="index" fixed="left" label="STT" width="55" align="center" />
<!--    <el-table-column label="Số hóa đơn" width="220" show-overflow-tooltip fixed="left">-->
<!--      <template v-slot:default="scope">-->
<!--        {{ scope.row.invoiceNo || scope.row.transactionUuid || "-" }}-->
<!--      </template>-->
<!--    </el-table-column>-->

    <el-table-column label="Họ tên" min-width="220" fixed="left" prop="buyerName"/>
    <el-table-column label="Ngày tạo" width="190" align="center">
      <template v-slot:default="scope">
        {{ formatDateTime(scope.row.createdAt || scope.row.issuedAt) }}
      </template>
    </el-table-column>

    <el-table-column label="Phương thức TT" width="150" align="center">
      <template v-slot:default="scope">
        {{ scope.row.paymentMethodName || "-" }}
      </template>
    </el-table-column>

    <el-table-column label="Thanh toán" width="130" align="center">
      <template v-slot:default="scope">
        <span :style="{ color: scope.row.paymentStatus ? '#1e88e5' : '#fb8c00' }">
          {{ scope.row.paymentStatus ? "Đã TT" : "Chưa TT" }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="Tổng tiền không chịu thuế" prop="totalAmountWithoutTax" align="right" width="170">
      <template v-slot:default="scope">
        {{ formatCurrency(scope.row.totalAmountWithoutTax) }}
      </template>
    </el-table-column>
    <el-table-column label="Tổng tiền chịu thuế" prop="totalTaxAmount" align="right" width="170">
      <template v-slot:default="scope">
        {{ formatCurrency(scope.row.totalTaxAmount) }}
      </template>
    </el-table-column>
    <el-table-column label="Tổng tiền" prop="totalAmountWithTax" align="right" width="170">
      <template v-slot:default="scope">
        {{ formatCurrency(scope.row.totalAmountWithTax) }}
      </template>
    </el-table-column>

    <el-table-column label="Trạng thái" width="170" align="center">
      <template v-slot:default="scope">
        <span :style="{ color: statusColor(scope.row.invoiceStatus || scope.row.status), fontWeight: 500 }">
          {{ statusLabel(scope.row.invoiceStatus || scope.row.status) }}
        </span>
      </template>
    </el-table-column>

    <el-table-column label="Tác vụ" fixed="right" align="center" width="210">
      <template v-slot:default="scope">
         <el-tooltip content="Chỉnh sửa" placement="top">
           <el-button
             v-if="scope.row.invoiceStatus === 'ONEKIDS_DRAFT'"
             size="mini"
             type="info"
             circle
             icon="el-icon-edit"
             :loading="actionLoading.edit"
             @click.prevent="editDraft(scope.row)"
           />
         </el-tooltip>

        <el-tooltip content="Xem trước nháp" placement="top">
          <el-button
            size="mini"
            type="primary"
            circle
            icon="el-icon-view"
            :loading="actionLoading.preview"
            @click.prevent="previewDraft(scope.row)"
          />
        </el-tooltip>
        <el-tooltip content="Lập HĐ nháp trên S-Invoice" placement="top">
          <el-button
              v-if="scope.row.invoiceStatus === 'ONEKIDS_DRAFT'"
              size="mini"
              type="warning"
              circle
              icon="el-icon-document-copy"
              :loading="actionLoading.draft"
              @click.prevent="promptCreateDraft(scope.row)"
          />
        </el-tooltip>
        <el-tooltip content="Phát hành HĐ" placement="top">
          <el-button
            v-if="checkPermission(['send-tax-authority']) && getSinvoiceConfigField('usbDigitalSignature', false) === false"
            size="mini"
            type="success"
            circle
            icon="el-icon-upload2"
            :loading="actionLoading.issue"
            @click.prevent="issueInvoice(scope.row)"
          />
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>

  <el-dialog
    title="Xác nhận"
    :visible.sync="confirmIssueDialogVisible"
    width="420px"
    append-to-body
    :close-on-click-modal="false"
  >
    <div>Bạn có chắc chắn muốn phát hành hóa đơn không?</div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="confirmIssueDialogVisible = false">Hủy</el-button>
      <el-button type="primary" @click="handleConfirmIssueAction">Đồng ý</el-button>
    </span>
  </el-dialog>

  <el-dialog
    title="Xác nhận"
    :visible.sync="confirmCreateDraftDialogVisible"
    width="450px"
    append-to-body
    :close-on-click-modal="false"
  >
    <div>Bạn có chắc chắn muốn lập hóa đơn nháp cho hóa đơn này không?</div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="confirmCreateDraftDialogVisible = false">Hủy</el-button>
      <el-button type="primary" @click="handleConfirmCreateDraft">Đồng ý</el-button>
    </span>
  </el-dialog>

  </div>
</template>

<script>
import ElectronicInvoicesService from '@/services/ElectronicInvoicesService';
import NotifyMessage from '@/commonFuncion/NotifyMessage';
import sinvoiceConfigMixin from '@/global/mixin/sinvoiceConfig.mixin';
import checkPermission from "@/utils/permission";
export default {
  name: "InvoiceTabListOther",
  mixins: [sinvoiceConfigMixin],
   data() {
     return {
       actionLoading: {
         edit: false,
         preview: false,
         draft: false,
         issue: false,
       },
        multipleSelection: [],
        confirmIssueDialogVisible: false,
        pendingIssueRow: null,
        confirmCreateDraftDialogVisible: false,
        pendingDraftRow: null,
     };
   },
  props: {
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    emptyText: { type: String, default: "Không có dữ liệu" },
  },
  methods: {
    checkPermission,
    handleSelectionChange(val){
      this.multipleSelection = val;
      this.$emit('selection-change', Array.isArray(val) ? val : []);
    },
    formatCurrency(value) {
      return `${new Intl.NumberFormat("vi-VN").format(Number(value) || 0)} VND`;
    },
    formatDateTime(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      const hh = String(date.getHours()).padStart(2, "0");
      const mm = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const MM = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${hh}:${mm}:${ss} - ${dd}/${MM}/${yyyy}`;
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: 500;";
    },
    statusLabel(status) {
      const map = {
        ONEKIDS_DRAFT: "Lưu nháp",
        DRAFT: "HĐ nháp",
        ISSUED: "Đã phát hành",
      };
      return map[status] || status || "-";
    },
    statusColor(status) {
      const map = {
        ONEKIDS_DRAFT: "#fb8c00",
        DRAFT: "#78909c",
        ISSUED: "#1e88e5",
      };
      return map[status] || "#303133";
    },
    async previewDraft(row) {
      this.actionLoading.preview = true;
      try {
        const request = { transactionUuid: row.transactionUuid };
        const resp = await ElectronicInvoicesService.previewInvoiceFromDraft(request);
        const data = resp && resp.data ? resp.data : null;
        if (!data) {
          NotifyMessage.leftCornerNotificationError('Không có dữ liệu xem trước');
          return;
        }
        // Emit arraybuffer and request to parent so it can open dialog iframe and optionally save
        this.$emit('open-preview', { arraybuffer: data, request });
      } catch (err) {
        console.error(err);
        NotifyMessage.leftCornerNotificationError('Xem trước thất bại');
      } finally {
        this.actionLoading.preview = false;
      }
    },
    async createDraft(row) {
      this.actionLoading.draft = true;
      try {
        const request = { transactionUuid: row.transactionUuid };
        const resp = await ElectronicInvoicesService.createDraftInvoiceFromDraft(request);
        const ok = resp && (resp.data === true || resp.data && resp.data.data === true || resp.data.success);
        if (ok) {
          NotifyMessage.leftCornerNotificationSuccess('Tạo hóa đơn nháp thành công');
          this.$emit('refresh');
        } else {
          NotifyMessage.leftCornerNotificationError('Tạo hóa đơn nháp thất bại');
        }
      } catch (err) {
        console.error(err);
        NotifyMessage.leftCornerNotificationError('Tạo hóa đơn nháp lỗi');
      } finally {
        this.actionLoading.draft = false;
      }
    },
    async issueInvoice(row) {
      this.pendingIssueRow = row || null;
      this.confirmIssueDialogVisible = true;
    },
    promptCreateDraft(row) {
      this.pendingDraftRow = row || null;
      this.confirmCreateDraftDialogVisible = true;
    },
    async handleConfirmCreateDraft() {
      this.confirmCreateDraftDialogVisible = false;
      if (!this.pendingDraftRow) return;
      await this.createDraft(this.pendingDraftRow);
      this.pendingDraftRow = null;
    },
    handleConfirmIssueAction() {
      this.confirmIssueDialogVisible = false;
      this.handleSubmitIssue();
    },
    getUsbDigitalSignatureConfig() {
      return !!this.getSinvoiceConfigField('usbDigitalSignature', false);
    },
    async handleSubmitIssue() {
      if (!this.pendingIssueRow || !this.pendingIssueRow.transactionUuid) {
        NotifyMessage.leftCornerNotificationError('Không tìm thấy dữ liệu hóa đơn để phát hành');
        return;
      }

      this.actionLoading.issue = true;
      try {
        const request = { transactionUuid: this.pendingIssueRow.transactionUuid };
        const resp = this.getUsbDigitalSignatureConfig()
          ? await ElectronicInvoicesService.createInvoiceFromDraftByUsbToken(request)
          : await ElectronicInvoicesService.createInvoiceFromDraft(request);
        const ok = resp && (resp.data === true || resp.data && resp.data.data === true || resp.data.success);
        if (ok) {
          NotifyMessage.leftCornerNotificationSuccess('Phát hành hóa đơn thành công');
          this.pendingIssueRow = null;
          this.$emit('refresh');
        } else {
          NotifyMessage.leftCornerNotificationError('Phát hành hóa đơn thất bại');
        }
      } catch (err) {
        console.error(err);
        NotifyMessage.leftCornerNotificationError('Phát hành hóa đơn lỗi');
      } finally {
        this.actionLoading.issue = false;
      }
     },
     editDraft(row) {
       this.actionLoading.edit = true;
       this.$nextTick(() => {
         this.$emit('edit-draft', row);
         this.actionLoading.edit = false;
       });
     },
   },
};
</script>

